import User from "../data/User";
import { dispatch } from "../dispatcher/Dispatcher";
import AppEvent from "../events/AppEvent";
import { IProvisioningState } from "../view/dashboard/main/Provisioning";
import Api, {ApiCallback} from "./Api";
import { ApiErrors } from './ApiErrors';
import FormatUtil from '../util/FormatUtil';

export default class ApiCDR{

    URL_GETCDRS:string = "PSAPLink_Service/PSAPLinkWS/PSAPLinkERSGet/";
    URL_GEN_911_TRANSFER:string = "PSAPLink_Service/PSAPLinkWS/PSAPLinkGetTransferWrapper";
    URL_GETUSERS:string = "PSAPLink_Service/PSAPLinkWS/User_Search";
    URL_UPDATEUSER:string = "PSAPLink_Service/PSAPLinkWS/User_Update";
    URL_INSERTUSER:string = "PSAPLink_Service/PSAPLinkWS/User_Add";
    URL_DELETEUSER:string = "PSAPLink_Service/PSAPLinkWS/User_Delete";
    URL_CLEARPASSWORD:string = "PSAPLink_Service/PSAPLinkWS/User_Password_Clear";
    URL_SETPASSWORD:string = "PSAPLink_Service/PSAPLinkWS/User_Password_Set";
    URL_CLEARPASSWORDADMIN:string = "PSAPLink_Service/PSAPLinkWS/User_Password_Admin_Clear";

   
    async generate911Transfer($complete:ApiCallback,$details:IProvisioningState){
      let success:boolean=true;
      let error = ApiErrors.LOADING;
      try{
        const request:any = {};

        let zipCode = $details.zipCode.toUpperCase();

        request.authorization = Api.createAuthBlock(); //not sure we need this?
        request.token = User.state.loginToken;
        request.callbackNumber = $details.cbn;
        request.streetAddress = $details.address;
        request.city = $details.city;
        request.state = $details.state;
        request.zip = zipCode;
        request.name = $details.callerName;
        request.loc = $details.location_exact_comment;
        request.country = $details.country;

        let strURL:string = Api.strPSAPEvnURL+this.URL_GEN_911_TRANSFER;

        const response:any = await Api.fetchAsyncJSON(strURL, "POST", request);


        if(response && response.summary){
          if(response.summary.success){
              $complete(true,response);
          } else{
              $complete(false,error);
          }
        }
        else{
          $complete(false,error);
        }
      }catch($error){
          $complete(success,error);
      }
  }

  async updateUser($complete:ApiCallback,$details?:{username?:string, email?:string, user_role?:string, pk:string, password?:string, phone_number?:string}){


    let success:boolean=true;
    let error = ApiErrors.LOADING;
    try{
      const request:any = {};
      request.token = User.state.loginToken;
      

      if($details){
        if($details.username){
          request.username = $details.username;
        }
        if($details.email){
          request.email = $details.email;
        }
        if($details.user_role){
          request.user_role = $details.user_role;
        }
        if($details.pk){
          request.pk = $details.pk;
        }
        if($details.password){
          request.passcode = $details.password;
        }
        if($details.phone_number){
          const phoneNumber = FormatUtil.filterNonNumbers($details?.phone_number);
          request.phone_number = phoneNumber;
        }

      }
    

      let strURL:string = Api.strPSAPEvnURL+this.URL_UPDATEUSER;

      const response:any = await Api.fetchAsyncJSON(strURL, "POST", request);


      if(response && response.summary){
        if(response.summary.success){
            $complete(true,response);
        } else{
            $complete(false,error);
        }
      }
      else{
        $complete(false,error);
      }
    }catch($error){
        $complete(success,error);
    }
}

async addUser($complete:ApiCallback,$details:{username?:string, email?:string, user_role?:string, security_group_id?:string, phone_number?:string}){

  let success:boolean=true;
  let error = ApiErrors.LOADING;
  try{
    const request:any = {};
    request.token = User.state.loginToken;
    request.company_id = User.state.company_id;

    if($details){
      if($details.username){
        request.username = $details.username;
      }
      if($details.email){
        request.email = $details.email;
      }
      if($details.user_role){
        request.user_role = $details.user_role;
      }
      if($details.security_group_id){
        request.security_group_id = $details.security_group_id;
      }
      if($details.phone_number){
        const phoneNumber = FormatUtil.filterNonNumbers($details?.phone_number);
        request.phone_number = phoneNumber;
      }

    }
  

    let strURL:string = Api.strPSAPEvnURL+this.URL_INSERTUSER;

    const response:any = await Api.fetchAsyncJSON(strURL, "POST", request);


    if(response && response.summary){
      if(response.summary.success){
          $complete(true,response);
      } else{
          $complete(false,error);
      }
    }
    else{
      $complete(false,error);
    }
  }catch($error){
      $complete(success,error);
  }
}

async deleteUser($complete:ApiCallback,$details:{pk:string}){

  let success:boolean=true;
  let error = ApiErrors.LOADING;
  try{
    const request:any = {};
    request.token = User.state.loginToken;
    request.pk = $details.pk;

    let strURL:string = Api.strPSAPEvnURL+this.URL_DELETEUSER;

    const response:any = await Api.fetchAsyncJSON(strURL, "POST", request);

    if(response && response.summary){
      if(response.summary.success){
          $complete(true,response);
      } else{
          $complete(false,error);
      }
    }
    else{
      $complete(false,error);
    }
  }catch($error){
      $complete(success,error);
  }
}

    async getCDRS($complete:ApiCallback,$details?:{duration?:number, callbackNumber?:string}){
        let success:boolean=true;
        let error = ApiErrors.LOADING;

 
        let defaultCallHistoryTime = {
          minValue:"300",
          maxValue:"31536000",
        }

        let callDuration:number = Number(Api.strCallHistoryEnvTime)
                                  ?FormatUtil.valueLimit(Number(Api.strCallHistoryEnvTime),Number(defaultCallHistoryTime.minValue),Number(defaultCallHistoryTime.maxValue))
                                  :Number(defaultCallHistoryTime.minValue);

        try{
          const cdrRequest:any = {duration:callDuration};
          cdrRequest.token = User.state.loginToken;

          if($details){
            if($details.duration){
              cdrRequest.duration = $details.duration;
            }
            if($details.callbackNumber){
              cdrRequest.callbackNumber = $details.callbackNumber;
            }
          }

          let strURL:string = Api.strEvnURL+this.URL_GETCDRS;

          const cdrResponse:any = await Api.fetchAsyncJSON(strURL, "POST", cdrRequest);


          if(cdrResponse && cdrResponse.summary){
            if(cdrResponse.summary.success){

                let contactNumber:string = "";
                if(cdrResponse.contactNumber){
                    contactNumber = cdrResponse.contactNumber;
                    dispatch(AppEvent.GOT_CONTACT_NUMBER,{contactNumber:contactNumber});
                }

                $complete(true,cdrResponse);
            } else{
                 
                 if(cdrResponse.summary.code){
                   
                   let errorFromCode = ApiErrors.CALL_HISTORY_ERROR_CODES;

                   if(errorFromCode[0].error){
                      error = errorFromCode[0];
                   }
                   
                 } 

                $complete(false,error);
                
            }
          }
          else{
            $complete(false,error);
          }
        }catch($error){
            $complete(success,error);
        }
    }
  async getUsers($complete:ApiCallback,$details?:{email?:string}){
    let success:boolean=true;
    let error = ApiErrors.LOADING;

    try{
      const userRequest:any = {};
      
      userRequest.token = User.state.loginToken;
      userRequest.company_id = User.state.company_id;

      if($details){
        if($details.email){
          userRequest.email = $details.email;
        }
      }

      let strURL:string = Api.strEvnURL+this.URL_GETUSERS;

      const userResponse:any = await Api.fetchAsyncJSON(strURL, "POST",userRequest);

      if(userResponse && userResponse.summary){
        if(userResponse.summary.success){
            let email :string = "";
            $complete(true,userResponse);
        } else{
            $complete(false,error);
        }
      }
      else{
        $complete(false,error);
      }
    }catch($error){
        $complete(success,error);
    }
}

async clearPassword($complete:ApiCallback,$details?:{email?:string}){
  let success:boolean=true;
  let error = ApiErrors.LOADING;
  try{
    const request:any = {};

    request.authorization = Api.createAuthBlock(); 
    request.company_id = User.state.company_id;
 
    if($details){
      if($details.email){
        request.email = $details.email;
      }
    }
  
    let strURL:string = Api.strEvnURL+this.URL_CLEARPASSWORD;

    const response:any = await Api.fetchAsyncJSON(strURL, "POST", request);

    if(response && response.summary){
      if(response.summary.success){
          $complete(true,response);
      } else{
          $complete(false,error);
      }
    }
    else{
      $complete(false,error);
    }
 

  }catch($error){
      $complete(success,error);
  }
}


async clearPasswordAdmin($complete:ApiCallback,$details?:{email?:string}){
  let success:boolean=true;
  let error = ApiErrors.LOADING;
  try{
    const request:any = {};

    request.authorization = Api.createAuthBlock(); 
    //request.company_id = User.state.company_id;
 
    if($details){
      if($details.email){
        request.email = $details.email;
      }
    }
  
    let strURL:string = Api.strEvnURL+this.URL_CLEARPASSWORDADMIN;

    const response:any = await Api.fetchAsyncJSON(strURL, "POST", request);

    if(response && response.summary){
      if(response.summary.success){
          $complete(true,response);
      } else{
          $complete(false,error);
      }
    }
    else{
      $complete(false,error);
    }
 

  }catch($error){
      $complete(success,error);
  }
}

async setPassword($complete:ApiCallback,$details?:{email?:string, token?:string, passcode?:string}){
  let success:boolean=true;
  let error = ApiErrors.LOADING;
  try{
    const request:any = {};

    request.authorization = Api.createAuthBlock(); 
    request.company_id = User.state.company_id;
 
    if($details){
      if($details.email){
        request.email = $details.email;
      }
      if($details.token){
        request.token = $details.token;
      }
      if($details.passcode){
        request.passcode = $details.passcode;
      }
    }
  
    let strURL:string = Api.strEvnURL+this.URL_SETPASSWORD;

    const response:any = await Api.fetchAsyncJSON(strURL, "POST", request);

    if(response && response.summary){
      if(response.summary.success){
          $complete(true,response);
      } else{
          $complete(false,error);
      }
    }
    else{
      $complete(false,error);
    }
 

  }catch($error){
      $complete(success,error);
  }
      
}

}